module.exports = __webpack_public_path__ + "static/media/Ogg-Regular.6d4626cb.woff";